<script setup lang="ts">
import { EIcon } from 'common/enum/misc.enum';
import { shallowRef, toRefs, Component as VueComponent, watch } from 'vue';

const props = defineProps<{
  iconName: EIcon | string;
}>();
const { iconName } = toRefs(props);

const iconComponent = shallowRef<VueComponent | null>(null);

watch(
  iconName,
  async (): Promise<void> => {
    if (!iconName.value.length) return;
    iconComponent.value = (await import(`@/assets/icons/${iconName.value}Icon.vue`)).default;
  },
  { immediate: true },
);
</script>

<template>
  <component :is="iconComponent" :class="['flex-shrink-0']" />
</template>
